import { isPlainObject } from 'lodash';

export const calculateFiltersTotal = <F extends Record<string, any>>(
  filters: F,
  keysToExtractFromTotalCalculation: (keyof F)[] = [],
): number => {
  const total = Object.entries(filters).reduce((acc, [key, value]) => {
    if (
      ['page', 'pageSize', ...keysToExtractFromTotalCalculation].includes(key)
    ) {
      return acc;
    }

    if (Array.isArray(value)) {
      return acc + value.length;
    }

    if (isPlainObject(value)) {
      if (('from' in value && !!value.from) || ('to' in value && !!value.to)) {
        return acc + 1;
      }

      if ('value' in value && !!value.value.length) {
        return acc + 1;
      }
    }

    if (typeof value === 'string' && value.length) {
      return acc + 1;
    }

    if (typeof value === 'number' && !Number.isNaN(value)) {
      return acc + 1;
    }

    if (typeof value === 'boolean' && value) {
      return acc + 1;
    }

    return acc;
  }, 0);

  return total;
};
